"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleLookupNullValue = void 0;
const model_1 = require("../model");
const types_1 = require("../types");
const parser_1 = require("./parser");
const immer_1 = require("immer");
/**
 * lookup cv now leaves null by default.
 * When the formula refers to the lookup field as a parameter, some functions need to convert the null value to make it as expected.
 */
const handleLookupNullValue = (params) => {
    return (0, immer_1.produce)(params, draftParams => {
        draftParams.forEach(param => {
            if (param.node.name === parser_1.AstNodeType.ValueOperandNode
                && param.node.field.type === types_1.FieldType.LookUp
                && (0, model_1.handleNullArray)(param.value) == null) {
                param.value = null;
            }
        });
    });
};
exports.handleLookupNullValue = handleLookupNullValue;
//# sourceMappingURL=helper.js.map